/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_Q5Inputs */

const en_minifier_faq_q5 = /** @type {(inputs: Minifier_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should I minify JSON that my server already gzips?`)
};

const ko_minifier_faq_q5 = /** @type {(inputs: Minifier_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서버가 이미 gzip을 적용하는 JSON도 압축해야 하나요?`)
};

const ja_minifier_faq_q5 = /** @type {(inputs: Minifier_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーバがすでに gzip をかけている JSON も圧縮すべきですか`)
};

/**
* | output |
* | --- |
* | "Should I minify JSON that my server already gzips?" |
*
* @param {Minifier_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_q5 = /** @type {((inputs?: Minifier_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_q5(inputs)
	if (locale === "ko") return ko_minifier_faq_q5(inputs)
	return ja_minifier_faq_q5(inputs)
});